import { MultipartBody } from '@microsoft/kiota-abstractions';
import { defineStore } from 'pinia';
import type {
  PassengerDataFile,
  StagingPassengerData,
} from '@/api/client/models/index.ts';
import { useApiClient } from '@/hooks/api-hook.ts';

type UploadFile = Blob & {
  name?: string;
  type?: string;
};

async function createMultipartBody(input: UploadFile): Promise<MultipartBody> {
  const multipartBody = new MultipartBody();
  multipartBody.addOrReplacePart(
    'formFile',
    input.type || 'text/csv',
    await input.arrayBuffer(),
    undefined,
    input.name || 'passenger-data.csv'
  );
  return multipartBody;
}

export const usePassengerDataStore = defineStore('passengerData', () => {
  const apiClient = useApiClient();

  async function upload(input: UploadFile): Promise<StagingPassengerData[]> {
    const response = await apiClient.stagingPassengerData.createFromCsv.post(await createMultipartBody(input));
    return response ?? [];
  }

  async function uploadWithTourOperatorId(input: UploadFile, tourOperatorId: number): Promise<StagingPassengerData[]> {
    const response = await apiClient.stagingPassengerData.createFromCsv.post(await createMultipartBody(input), {
      queryParameters: {
        tourOperatorId,
      },
    });

    return response ?? [];
  }

  async function commit(): Promise<PassengerDataFile[]> {
    const response = await apiClient.stagingPassengerData.insertSelectedPassengerData.post();
    return response ?? [];
  }

  return {
    upload,
    uploadWithTourOperatorId,
    commit,
  };
});
